import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes
} from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuthStore } from "./context/AuthContext";
import { LayoutProvider } from "./context/LayoutContext";
import PrivateRoute from "./components/guards/PrivateRoute";
import SidebarWrapper from "./components/shared/sidebar/SidebarWrapper";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/Dashboard";
import Professor from "./pages/Professor";
import Doctor from "./pages/Doctor";
import Trusty from "./pages/Trusty";
import Gallery from "./pages/Gallery";
import ContactSubmissions from "./pages/ContactSubmissions";
import SocialLinks from "./pages/SocialLinks";
import MetadataManagement from "./pages/MetadataManagement";
import Courses from "./pages/Courses";
import Events from "./pages/Events";
import Career from "./pages/Career";
import CareerApplications from "./pages/CareerApplications";
import Departments from "./pages/Departments";
import Categories from "./pages/Categories";
import EditableProfileModule from "./pages/EditableProfileModule";
import ManagingTrustee from "./pages/ManagingTrustee";
import NmcProforma from "./pages/NmcProforma";
import GovApproval from "./pages/GovApproval";
import Committee from "./pages/Committee";
import Publication from "./pages/Publication";


function AppContent() {
  const { tokens } = useAuthStore();

  return (
    <>
      <Router>
        <LayoutProvider>
          <Routes>
            <Route path="/auth/login" element={<Login />} />
            <Route
              element={
                <PrivateRoute>
                  <SidebarWrapper>
                    <Outlet />
                  </SidebarWrapper>
                </PrivateRoute>
              }
            >
              <Route
                path="/"
                element={
                  tokens ? <Navigate to="/dashboard" replace /> : <Navigate to="/auth/login" replace />
                }
              />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/professors" element={<Professor />} />
              <Route path="/doctors" element={<Doctor />} />
              <Route path="/trusty" element={<Trusty />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contacts" element={<ContactSubmissions />} />
              <Route path="/social-links" element={<SocialLinks />} />
              <Route path="/metadata" element={<MetadataManagement />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/events" element={<Events />} />
              <Route path="/career" element={<Career />} />
              <Route path="/career-applications" element={<CareerApplications />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/nmc-proforma" element={<NmcProforma />} />
              <Route path="/gov-approvals" element={<GovApproval />} />
              <Route path="/committees" element={<Committee />} />
              <Route path="/publications" element={<Publication />} />
              <Route
                path="/ceo"
                element={
                  <EditableProfileModule
                    moduleKey="ceo"
                    responseKey="ceo"
                    eyebrow="Profile Module"
                    title="CEO"
                    description="Manage the CEO profile with name, image, position, and editor-based description."
                    uploadFolder="ceo"
                  />
                }
              />
              <Route
                path="/dean"
                element={
                  <EditableProfileModule
                    moduleKey="dean"
                    responseKey="dean"
                    eyebrow="Profile Module"
                    title="Dean"
                    description="Manage dean details with name, image, position, and editor-based description."
                    uploadFolder="dean"
                  />
                }
              />
              <Route
                path="/medical-superintendent"
                element={
                  <EditableProfileModule
                    moduleKey="medical-superintendent"
                    responseKey="medicalSuperintendent"
                    eyebrow="Profile Module"
                    title="Medical Superintendent"
                    description="Manage Medical Superintendent details with name, image, position, and editor-based description."
                    uploadFolder="medical-superintendent"
                  />
                }
              />
              <Route
                path="/dysm"
                element={
                  <EditableProfileModule
                    moduleKey="dysm"
                    responseKey="dysm"
                    eyebrow="Profile Module"
                    title="Dysm"
                    description="Manage Dysm details with name, image, position, and editor-based description."
                    uploadFolder="dysm"
                  />
                }
              />
              <Route path="/deal" element={<Navigate to="/dean" replace />} />
              <Route path="/managing-trustees" element={<ManagingTrustee />} />



            </Route>
            <Route path="*" element={<Navigate to={tokens ? "/dashboard" : "/auth/login"} replace />} />
          </Routes>
        </LayoutProvider>
      </Router>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
